import { ceApiClient } from './ceApiClient';
import type {
  CELoginRequest,
  CELoginResponse,
  CEMeResponse,
} from '../auth/types';

export const ceAuthService = {
  async login(credentials: CELoginRequest): Promise<CELoginResponse> {
    const response = await ceApiClient.post<CELoginResponse>(
      '/component-explorer/auth/login',
      credentials,
    );
    return response.data;
  },

  async logout(): Promise<void> {
    await ceApiClient.post('/component-explorer/auth/logout');
  },

  async me(): Promise<CEMeResponse> {
    const response =
      await ceApiClient.get<CEMeResponse>('/component-explorer/auth/me');
    return response.data;
  },
};
